module.exports = __webpack_public_path__ + "img/sku2.ae71fb47.png";